var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.publisher_title)?_c('span',{staticClass:"campaign-publisher",attrs:{"title":"Publisher"}},[_vm._v("\n  "+_vm._s(_vm.publisher_title)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }